import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { DomainDefinitionService } from '../../../../builder/services/domain-definition.service';
import { ReportSelectorService } from '../../../../form-controls/services/report-selector.service';
import { Organization } from '../../../models/organization.model';
import { ReportingService } from '../../../services/reporting.service';
import { DomainValue } from '../../../../models/domain.model';
import { LoaderService } from '../../../services/loader.service';
import { Subscription } from 'rxjs';
import { filter, finalize } from 'rxjs/operators';
import { IReportContextValue, ReportTemplate } from '../../../../models/comodel/mergefieldsmodel.model';

@Component({
    selector: 'communication-selector',
    templateUrl: './communication-selector.component.html',
    standalone: false
})
export class CommunicationSelectorComponent implements OnInit, OnDestroy {

    @Input() org: Organization;
    sub: Subscription[] = [];
    activeCategories: DomainValue[];
    activeTemplates: ReportTemplate[];
    chiefOrderCategories: DomainValue[];
    chiefOrderTemplates: ReportTemplate[];
    types: DomainValue[];
    letterCategories: DomainValue[];
    letterTemplates: ReportTemplate[];
    selectedCategory: string;
    selectedTemplateId: string;
    selectedTypeCode: string;
    info: IReportContextValue; 

    constructor(public dataService: ReportingService,
        public domainService: DomainDefinitionService,
        public loader: LoaderService,
        public reportService: ReportSelectorService,
        public router: Router) { }

    ngOnInit() {
        this.getData();

        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.sub.forEach(s => { if (s) s.unsubscribe(); });
        });
    }
    ngOnDestroy(): void {
        this.sub.forEach(s => { if (s) s.unsubscribe(); });
    }

    categoryChanged(catCode: string): void {
        switch (this.selectedTypeCode) {
            case 'CO': {
                this.activeTemplates = this.chiefOrderTemplates;
                break;
            }
            case 'Letter': {
                this.activeTemplates = this.letterTemplates;
                break;
            }
            default: {
                this.activeTemplates = [];
                break;
            }
        }
        this.activeTemplates = this.activeTemplates.filter(x => x.categoryCode === catCode);
        this.selectedCategory = catCode;
        this.selectedTemplateId = null;
    }

    dataLoaded(): boolean {
        if (this.types && this.letterCategories && this.chiefOrderCategories && this.chiefOrderTemplates && this.letterTemplates)
            return true;
        return false;
    }


    getData(): void {
        var domain$ = this.domainService.get('CommunicationType')
            .pipe(
                finalize(() => {
                    this.sub.push(domain$);
                })
            )
            .subscribe(data => {
                this.types = data.values;
            });

        var service$ = this.domainService.get('LetterCategory')
            .pipe(
                finalize(() => {
                    this.sub.push(service$);
                })
            )
            .subscribe(data => {
                this.letterCategories = data.values;
            });

        var dService$ = this.domainService.get('ChiefsOrderCategory')
            .pipe(
                finalize(() => {
                    this.sub.push(dService$);
                })
            )
            .subscribe(data => {
                this.chiefOrderCategories = data.values;
            });

        var rpt$ = this.reportService.getTemplates('co')
            .pipe(
                finalize(() => {
                    this.sub.push(rpt$);
                })
            )
            .subscribe(data => {
                this.chiefOrderTemplates = data;
            });

        var rService$ = this.reportService.getTemplates('letter')
            .pipe(
                finalize(() => {
                    this.sub.push(rService$);
                })
            )
            .subscribe(data => {
                this.letterTemplates = data;
            });
    }

    instantiate(): void {
        const template = this.activeTemplates.find(x => x.id == this.selectedTemplateId);
        let navigationPath = ""
        if (!template) {
            console.log('Communication selector component tried to instantiate a template that could not be found: ' + this.selectedTemplateId);
            return;
        }

        if (template.typeCode.toLowerCase() == "co") {
            navigationPath = '/admin/chief-orders/co-level-mergefields/' + template.id + '/' + this.org.id + '/' + template.categoryCode;
        }

        if (template.typeCode.toLowerCase() == "letter") {
            navigationPath = '/admin/communications/letter-mergefields/' + template.id + '/' + this.org.id + '/' + template.categoryCode;
        }

        window.open(navigationPath, "_blank");
    }

    templateChanged(templateId: string): void {
        this.selectedTemplateId = templateId;
    }

    typeChanged(typeCode: string): void {
        switch (typeCode) {
            case 'CO': {
                this.activeCategories = this.chiefOrderCategories;
                break;
            }
            case 'Letter': {
                this.activeCategories = this.letterCategories;
                break;
            }
            default: {
                this.activeCategories = null;
                break;
            }
        }
        this.activeTemplates = null;
        this.selectedCategory = null;
        this.selectedTemplateId = null;
        this.selectedTypeCode = typeCode;
    }

}
